webpackJsonp([27],{

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(542)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(569),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17e5f1c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id', 'type'],
  data: function data() {
    return {
      err: '',
      config: {}
    };
  },

  watch: {
    id: function id() {
      this.fetchConfigData();
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm');
    },
    fetchConfigData: function fetchConfigData() {
      var _this = this;

      var url = this.type + '/configupdates/' + this.id;
      this.$http.get(url).then(function (res) {
        if (res.body.status === 'Success') {
          _this.config = res.body.config;
          return;
        }
        _this.err = res.body.statusText;
      }, function (err) {
        _this.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    this.fetchConfigData();
  }
});

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, ".close-btn[data-v-17e5f1c6]{right:8px;top:8px}p[data-v-17e5f1c6]{font-size:16px;color:#ffb300}p span[data-v-17e5f1c6],ul[data-v-17e5f1c6]{color:rgba(0,0,0,.75)}ul[data-v-17e5f1c6]{padding-left:18px}.no-data[data-v-17e5f1c6]{color:rgba(0,0,0,.57)}.arrow-down[data-v-17e5f1c6],.arrow-up[data-v-17e5f1c6]{cursor:pointer}.arrow-down i[data-v-17e5f1c6],.arrow-up i[data-v-17e5f1c6]{font-size:50px!important;color:rgba(0,0,0,.75)!important}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/configUpdates/ConfigUpdateView.vue"],"names":[],"mappings":"AACA,4BACE,UAAW,AACX,OAAS,CACV,AACD,mBACE,eAAgB,AAChB,aAAe,CAChB,AAID,4CAFI,qBAA2B,CAK9B,AAHD,oBACE,iBAAmB,CAEpB,AACD,0BACE,qBAA2B,CAC5B,AACD,wDAEE,cAAgB,CACjB,AACD,4DAEI,yBAA2B,AAC3B,+BAAsC,CACzC","file":"ConfigUpdateView.vue","sourcesContent":["\n.close-btn[data-v-17e5f1c6] {\n  right: 8px;\n  top: 8px;\n}\np[data-v-17e5f1c6] {\n  font-size: 16px;\n  color: #FFB300;\n}\np span[data-v-17e5f1c6] {\n    color: rgba(0, 0, 0, 0.75);\n}\nul[data-v-17e5f1c6] {\n  padding-left: 18px;\n  color: rgba(0, 0, 0, 0.75);\n}\n.no-data[data-v-17e5f1c6] {\n  color: rgba(0, 0, 0, 0.57);\n}\n.arrow-down[data-v-17e5f1c6],\n.arrow-up[data-v-17e5f1c6] {\n  cursor: pointer;\n}\n.arrow-down i[data-v-17e5f1c6],\n  .arrow-up i[data-v-17e5f1c6] {\n    font-size: 50px !important;\n    color: rgba(0, 0, 0, 0.75) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(516);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("213dd848", content, true, {});

/***/ }),

/***/ 569:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-layout', {
    staticClass: "arrow-up py-2",
    attrs: {
      "row": "",
      "align-center": "",
      "justify-center": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('prev')
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_up")])], 1), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "align-start": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.created) + ": "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.config.createdOn)))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.synched) + ":\n          "), (_vm.config.synchedOn) ? _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.config.synchedOn)))]) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.companyName) + ": "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.config.companyName))])])]), _vm._v(" "), (_vm.config.refreshCorporation) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.corporation) + ": "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.config.refreshCorporation))])])]) : _vm._e(), _vm._v(" "), (this.type === 'moon') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.moonInstName) + ": "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.config.moonInsatanceName))])])]) : _vm._e(), _vm._v(" "), (this.type === 'planet') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.planetInstName) + ": "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.config.planetInstanceName))])])]) : _vm._e(), _vm._v(" "), (_vm.config.status) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.status) + ": "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.config.status))])])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.companyDataUpdated) + ":\n          "), (_vm.config.refreshCompanyData) ? _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.config.refreshCompanyData === true ? 'Yes' : 'No'))]) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.accounts) + ":\n          "), (_vm.config.refreshAccounts) ? _c('ul', _vm._l((_vm.config.refreshAccounts), function(account, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(account))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.printers) + ":\n          "), (_vm.config.refreshPrinters) ? _c('ul', _vm._l((_vm.config.refreshPrinters), function(printer, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(printer))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.printTemplates) + ":\n          "), (_vm.config.refreshPrintTemplates) ? _c('ul', _vm._l((_vm.config.refreshPrintTemplates), function(template, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(template))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.printServers) + ":\n          "), (_vm.config.refreshPrintServers) ? _c('ul', _vm._l((_vm.config.refreshPrintServers), function(server, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(server))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.catalogs) + ":\n          "), (_vm.config.refreshCatalogs) ? _c('ul', _vm._l((_vm.config.refreshCatalogs), function(catalog, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(catalog))])
  }), 0) : (_vm.config.refreshCatalogData) ? _c('ul', _vm._l((_vm.config.refreshCatalogData), function(catalog, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(catalog))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), (_vm.config.tables) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.tables) + ":\n          "), (_vm.config.tables) ? _c('ul', _vm._l((_vm.config.tables), function(tables, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(tables))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]) : _vm._e(), _vm._v(" "), (_vm.config.tableCategories) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.tableCategories) + ":\n          "), (_vm.config.tableCategories) ? _c('ul', _vm._l((_vm.config.tableCategories), function(tableCat, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(tableCat))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]) : _vm._e(), _vm._v(" "), (_vm.config.refreshTables) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.tables) + ":\n        "), (_vm.config.refreshTables) ? _c('ul', _vm._l((_vm.config.refreshTables), function(tables, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(tables))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]) : _vm._e(), _vm._v(" "), (_vm.config.refreshTableCategories) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.tableCategories) + ":\n        "), (_vm.config.refreshTableCategories) ? _c('ul', _vm._l((_vm.config.refreshTableCategories), function(tableCat, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(tableCat))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.callerIdServers) + ":\n          "), (_vm.config.refreshCallerIdServers) ? _c('ul', _vm._l((_vm.config.refreshCallerIdServers), function(callerID, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(callerID))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.webShopResource) + ":\n          "), (_vm.config.refreshWebShopResourceNames) ? _c('ul', _vm._l((_vm.config.refreshWebShopResourceNames), function(tableCat, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(tableCat))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.langMapforPrintCat) + ":\n          "), _c('br'), _vm._v(" "), (_vm.config.refreshPrinterCategoryLanguageMappings) ? _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.config.refreshPrinterCategoryLanguageMappings === true ? 'Yes' : 'No'))]) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.discountRules) + ":\n          "), (_vm.config.refreshDiscountRules) ? _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.config.refreshDiscountRules === true ? 'Yes' : 'No'))]) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.discountRuleNames) + ":\n          "), (_vm.config.refreshDiscountRuleNames) ? _vm._l((_vm.config.refreshDiscountRuleNames), function(ruleName, index) {
    return _c('ul', {
      key: index
    }, [_c('li', [_vm._v(_vm._s(ruleName))])])
  }) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])], 2)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.depReceipts) + ":\n          "), (_vm.config.depReceipts) ? _vm._l((_vm.config.depReceipts), function(dep, index) {
    return _c('ul', {
      key: index
    }, [_c('li', [_vm._v(_vm._s(dep))])])
  }) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])], 2)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.paymentTerminals) + ":\n          "), (_vm.config.refreshPaymentTerminals) ? _vm._l((_vm.config.refreshPaymentTerminals), function(terminal, index) {
    return _c('ul', {
      key: index
    }, [_c('li', [_vm._v(_vm._s(terminal))])])
  }) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])], 2)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.paymentServers) + ":\n          "), (_vm.config.refreshPaymentServers) ? _vm._l((_vm.config.refreshPaymentServers), function(server, index) {
    return _c('ul', {
      key: index
    }, [_c('li', [_vm._v(_vm._s(server))])])
  }) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])], 2)])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "close-btn",
    attrs: {
      "fab": "",
      "small": "",
      "flat": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "arrow-down py-2",
    attrs: {
      "row": "",
      "align-center": "",
      "justify-center": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('next')
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/27.6bcb4a668b5c79da0776.js